import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { GridOptions } from "ag-grid/main";
import {AccessControl,UserRolePagesMapping,Role,EDIT_BTN} from '../shared';
import { CommonUtility, ServerConstantsService, DataService, APP_DATE_FORMAT } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-access-control-summary',
  templateUrl: './access-control-summary.component.html',
  styleUrls: ['./access-control-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AccessControlSummaryComponent implements OnInit {

  ServerConstants: any;
  response:AccessControl;
  roles:Role[];
  columnDefs: any;
  context: any;
  gridOptions: GridOptions;
  gridApi:any;
  tabToNextCell:any;
  firstTime: Boolean = true;

  userActionNotificationsMap: any;
  noData: Boolean = false;
  EDIT_BTN: string = EDIT_BTN;

  error: Boolean = false;

  private _success = new Subject<string>();
  successMessage: string;

  private _danger = new Subject<string>();
  errorMessage: string;

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    //private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit() {
    this.http.get<any>(this.ServerConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            console.log('role : ' + data.roles[0].id);
            if(data.roles[0].id === 5){
                this.router.navigate(['dashboard']);
              }
            }
          } 

    this.load();

    /* Success message*/
    this._success.subscribe((message) => this.successMessage = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = null);
    /* error message */
    this._danger.subscribe((message) => this.errorMessage = message);
    this._danger.pipe(
      debounceTime(5000)
    ).subscribe(() => this.errorMessage = null);

    this.getColumnDefinitions();
  

}, response => {
console.log('error', response);
if(response.status === 401){
this.router.navigate(['dashboard']);
}
}, () => {

});
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Role',
        field: 'name',
        width: 700,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        width: 650
      },
    ];
    this.context = {
      component: this
    }

    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if(nextCell.column.colDef.headerName === "Action"){
        return;
      }
      else{
        return nextCell;
      }
    }
  }

  getEditButton(params) {
    const that = params.context.component;
    // Edit Button
    const element = document.createElement('a');
    const image = EDIT_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap("accessRoleId", params.data.id);
      that.router.navigate(['admin/accesscontrol/details']);
    });

    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.dataService.addValueToSharedDataMap("accessRoleId", params.data.id);
        that.router.navigate(['admin/accesscontrol/details']);
      }
      else if((!event.shiftKey && event.keyCode==9) && (params.rowIndex == (that.roles.length -1))){
        event.preventDefault();
        setTimeout(() => that.header.nativeElement.focus(), 0);
        that.header.nativeElement.click();
      }

    });
    element.setAttribute("tabindex", "0");
    return element;
  }

  load(){
    this.http.get<AccessControl>(this.ServerConstants.SERVER_API_URL+'/accesscontrol/getAllRoles' ).subscribe(
      (data) => {
        if(data.hasOwnProperty('errorCode')){
          // this.notificationService.error('Payment Summary', this.userActionNotificationsMap.ERROR);
        }else{
          if (data.roleList.length > 0 ){
            this.roles = data.roleList;
          }else{
            this.roles = undefined;
            this.noData = true;
          }
        }
      },response => {
        this.error = true;
        this.notificationService.error('Access Control Summary', this.userActionNotificationsMap.ERROR);
      },() => {
        this.error = false;
      });
  }

  parseRefTableData(myData){
    if(myData !== undefined && myData.englishDropDown){

      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }

  convertCode(myMap, code){
    if(myMap !== undefined){
      return myMap.get(code);
    }
  }

  onGridReady(params) {
    this.gridOptions.api = params.api;
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  focusSummary(event) {
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }
    if(this.roles.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-control-summary/access-control-summary.component.ts